export const houseNumberAdditionPattern = {
  value: /^[\da-zA-Z\s]{0,10}$/i,
  message: 'Vul een geldige toevoeging in.',
};

